(function(){
  function enhance(container){
    if(container.dataset.pbhSliderDone) return;
    var minInput = container.querySelector('input[name*="price.gte"], input.price-range__min, input[name*="[gte]"]');
    var maxInput = container.querySelector('input[name*="price.lte"], input.price-range__max, input[name*="[lte]"]');
    if(!minInput || !maxInput) return;
    container.dataset.pbhSliderDone = "1";
    var boundsMin = parseFloat(minInput.min || minInput.getAttribute('data-min') || 0) || 0;
    var boundsMax = parseFloat(maxInput.max || maxInput.getAttribute('data-max') || 500) || 500;
    var step = parseFloat(minInput.step) || 1;
    var wrap = document.createElement('div');
    wrap.className = 'pbh-pslider';
    wrap.innerHTML =
      '<div class="rail"></div><div class="fill"></div>' +
      '<input type="range" class="pbh-r-min" min="'+boundsMin+'" max="'+boundsMax+'" step="'+step+'">' +
      '<input type="range" class="pbh-r-max" min="'+boundsMin+'" max="'+boundsMax+'" step="'+step+'">';
    container.insertBefore(wrap, container.firstChild);
    var labels = document.createElement('div');
    labels.className = 'pbh-pslider-labels';
    labels.innerHTML = '<span class="pbh-lbl-min"></span><span class="pbh-lbl-max"></span>';
    container.insertBefore(labels, wrap.nextSibling);
    var rMin = wrap.querySelector('.pbh-r-min');
    var rMax = wrap.querySelector('.pbh-r-max');
    var fill = wrap.querySelector('.fill');
    var lblMin = labels.querySelector('.pbh-lbl-min');
    var lblMax = labels.querySelector('.pbh-lbl-max');
    function fmt(v){ return '$' + Math.round(v); }
    function paint(){
      var a = parseFloat(rMin.value), b = parseFloat(rMax.value);
      var pctA = ((a - boundsMin) / (boundsMax - boundsMin)) * 100;
      var pctB = ((b - boundsMin) / (boundsMax - boundsMin)) * 100;
      fill.style.left = pctA + '%';
      fill.style.width = Math.max(0, pctB - pctA) + '%';
      lblMin.textContent = fmt(a);
      lblMax.textContent = fmt(b);
    }
    function syncFromInputs(){
      rMin.value = minInput.value || boundsMin;
      rMax.value = maxInput.value || boundsMax;
      paint();
    }
    rMin.addEventListener('input', function(){
      if(parseFloat(rMin.value) > parseFloat(rMax.value)) rMin.value = rMax.value;
      minInput.value = rMin.value;
      paint();
    });
    rMax.addEventListener('input', function(){
      if(parseFloat(rMax.value) < parseFloat(rMin.value)) rMax.value = rMin.value;
      maxInput.value = rMax.value;
      paint();
    });
    function commit(){
      minInput.dispatchEvent(new Event('input', {bubbles:true}));
      minInput.dispatchEvent(new Event('change', {bubbles:true}));
      maxInput.dispatchEvent(new Event('input', {bubbles:true}));
      maxInput.dispatchEvent(new Event('change', {bubbles:true}));
    }
    rMin.addEventListener('change', commit);
    rMax.addEventListener('change', commit);
    minInput.addEventListener('change', syncFromInputs);
    maxInput.addEventListener('change', syncFromInputs);
    syncFromInputs();
  }
  function scan(){
    document.querySelectorAll('price-range, .price-range, [data-price-range], .facets__price').forEach(enhance);
  }
  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
  var mo = new MutationObserver(function(){ scan(); });
  mo.observe(document.body, {childList:true, subtree:true});
  scan();
})();